import React from "react";
import PropTypes from "prop-types";
import HierarchyTreeIcon from "./hierarchy-tree-icon";

class HierarchyTreeItem extends React.Component {
  get paddingLeft() {
    return `${this.props.indentSize * this.props.layer + (this.props.isNotLeaf ? 0 : 24)}px`;
  }

  render() {
    return (
      <div
        className="bg-light my-1 w-100"
        data-id={this.props.keyId}
        style={{
          paddingLeft: this.paddingLeft,
        }}
      >
        {this.props.isNotLeaf ? (
          <HierarchyTreeIcon
            className="mx-1"
            data-id={this.props.keyId}
            onClick={this.props.onIconClick}
            plus={this.props.plus}
          />
        ) : null}
        <span
          className="pr-2 pb-1"
          data-id={this.props.keyId}
          id={this.props.tooltipAncor ? `id_${this.props.keyId}` : undefined}
          style={{
            ...this.props.style,
            display: "inline-block",
            minHeight: `${this.props.indentSize}px`,
          }}
        >
          {this.props.name}
        </span>
      </div>
    );
  }
}

HierarchyTreeItem.propTypes = {
  indentSize: PropTypes.number,
  isNotLeaf: PropTypes.bool,
  layer: PropTypes.number,
  keyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      text: PropTypes.string,
    }),
  ),
  name: PropTypes.string,
  onIconClick: PropTypes.func,
  plus: PropTypes.bool,
  style: PropTypes.object,
  tooltipAncor: PropTypes.bool,
};

HierarchyTreeItem.defaultProps = {
  indentSize: 0,
  layer: 0,
  tooltipAncor: false,
};

export default HierarchyTreeItem;
